import styled from 'styled-components'
import { motion } from 'framer-motion'

export const SearchBarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex-shrink: 0;
  padding: 0.65rem clamp(1rem, 4vw, 3rem) 0.85rem;
  background-color: #000000db;
  z-index: 100;
  width: 95%;
  min-height: 83px;
  border-bottom: 1px solid #292929;
  border-radius: 0 0 25px 25px;
  margin: 0 auto;
  overflow: visible;
  box-shadow: 0 1px 9px 1px #000000;
`

export const TopBarContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  padding: 0.25rem 0;
`

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
  width: 100%;
  border-bottom: 1px solid #111111;
  padding-bottom: 0.2em;
`

export const SearchFieldGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
`

export const HistoryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 28px;
  padding: 0 1em;
  border: 1px solid #3a3a3a;
  border-radius: 0.35rem;
  background-color: rgba(255, 255, 255, 0.02);
  color: #7a7a7a;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: rgba(120, 188, 40, 0.65);
    color: #78bc28;
    background-color: rgba(120, 188, 40, 0.06);
  }

  &:focus-visible {
    outline: 2px solid rgba(120, 188, 40, 0.65);
    outline-offset: 2px;
  }

  & span {
    font-size: 1.3rem;
  }
  & svg {
    font-size: 1.5rem;
    margin-left: 0.5em;
  }
`

export const SearchField = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 0.55rem;
  flex-shrink: 0;
  padding: 0.45rem 0.9rem;
  border: 1px solid ${({ $focused }) => ($focused ? 'rgba(120, 188, 40, 0.65)' : '#3a3a3a')};
  border-radius: 0.35rem;
  background-color: rgba(255, 255, 255, 0.02);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: ${({ $focused }) =>
    $focused ? '0 0 0 1px rgba(120, 188, 40, 0.15)' : 'none'};
`

export const SearchIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  color: ${({ $focused }) => ($focused ? '#78bc28' : '#7a7a7a')};
  transition: color 0.2s ease;
`

export const SearchInput = styled.input`
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #f0f0f0;
  font-family: 'Chivo', sans-serif;
  font-size: 1.3rem;
  font-style: italic;

  &::placeholder {
    color: #7a7a7a;
    font-style: italic;
  }

  &::-webkit-search-cancel-button {
    display: none;
  }
`

export const ClearSearchButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #7a7a7a;
  cursor: pointer;
  line-height: 1;
  transition: color 0.2s ease;

  &:hover {
    color: #f0f0f0;
  }

  &:focus-visible {
    outline: 2px solid rgba(120, 188, 40, 0.65);
    outline-offset: 2px;
    border-radius: 2px;
  }
`

export const SortButtonsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
`

export const SortButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  flex-shrink: 0;
  padding: 0.45rem 1.1rem;
  border: 1px solid #ffffff;
  border-radius: 999px;
  background: ${({ $active }) =>
    $active
      ? 'linear-gradient(358deg, #78b529, #219c26)'
      : '#000000'};
  color: #ffffff;
  font-family: 'Chivo', sans-serif;
  font-size: 1.1rem;
  font-weight: 700;
  font-style: italic;
  white-space: nowrap;
  cursor: pointer;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
  transition: background 0.15s ease, transform 0.15s ease;

  &:hover {
    background: ${({ $active }) =>
      $active
        ? 'linear-gradient(358deg, #8acc2f, #28b02e)'
        : 'linear-gradient(358deg, #2a2a2a, #1a1a1a)'};
  }

  &:active {
    transform: scale(0.98);
  }
`

export const SortDirectionIcon = styled.span`
  display: inline-flex;
  line-height: 1;
  visibility: ${({ $visible = true }) => ($visible ? 'visible' : 'hidden')};
`
